import { animation } from "./animation";

// mdc.ripple.MDCRipple.attachTo(document.querySelector('.foo-button'));
try {
  mdc.autoInit();
} catch(e) {}
try {
	mdc.textField.MDCTextField.attachTo(document.querySelector('#get-started-form-input-email'));
	mdc.textField.MDCTextField.attachTo(document.querySelector('#newsletter-form-input-email'));
	mdc.textField.MDCTextField.attachTo(document.querySelector('#newsletter-form-input-keywords'));
} catch(e) {}
try {
	mdc.textField.MDCTextField.attachTo(document.querySelector('#modal-form-input-name'));
	mdc.textField.MDCTextField.attachTo(document.querySelector('#modal-form-input-email'));
} catch(e) {}
try {
	mdc.textField.MDCTextField.attachTo(document.querySelector('#modal-form-input-website'));
	mdc.textField.MDCTextField.attachTo(document.querySelector('#modal-form-input-keywords'));
} catch(e) {}
try {
	// mdc.textField.MDCTextField.attachTo(document.querySelector('#plans-form-input-spend'));
	mdc.select.MDCSelect.attachTo(document.querySelector('#plans-form-select-spend'));
} catch(e) {}
try {
	mdc.textField.MDCTextField.attachTo(document.querySelector('#plans-form-input-email'));
} catch(e) {}
try {
	// mdc.textField.MDCTextField.attachTo(document.querySelector('#cost-form-input-looking-for'));
	// mdc.textField.MDCTextField.attachTo(document.querySelector('#cost-form-input-website'));
} catch(e) {}
try {
	mdc.select.MDCSelect.attachTo(document.querySelector('.cost-form-select-service'));
	mdc.select.MDCSelect.attachTo(document.querySelector('.cost-form-select-website'));
} catch(e) {}

console.log(mdc);

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require("./bootstrap");

// window.Vue = require("vue");

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component("example-component", require("./components/ExampleComponent.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
// 	el: "#app",
// });

// const carouselContainer = document.querySelector('.logo-container');

// // Clone the carousel content to create a continuous loop
// const carouselItems = carouselContainer.innerHTML;
// carouselContainer.innerHTML += carouselItems;

// Set up animation
// let scrollLeft = 0;
// const scrollSpeed = 8; // Adjust the scroll speed as needed

// function animateCarousel(timestamp) {
//     if (!lastTimestamp) {
//         lastTimestamp = timestamp;
//     }

//     const deltaTime = timestamp - lastTimestamp;
//     lastTimestamp = timestamp;

//     scrollLeft += scrollSpeed * deltaTime / 60; // Normalize speed
//     if (scrollLeft >= carouselContainer.scrollWidth / 2) {
//         scrollLeft = 0;
//     }
//     carouselContainer.style.transform = `translateX(-${scrollLeft}px)`;

//     requestAnimationFrame(animateCarousel);
// }

// let lastTimestamp = null;
// requestAnimationFrame(animateCarousel);

// new Splide( '.splide', {
//     perPage: 2
// }).mount();

// Dropdown menu functionality for main & mobile header
jQuery(function(){
	jQuery('.dropdown-main').hover(function() {
		jQuery('.dropdown-menu-main').addClass('show');
		jQuery(this).addClass('show');
	},
	function() {
		jQuery('.dropdown-menu-main').removeClass('show');
		jQuery(this).removeClass('show');
	});
});
jQuery(function(){
	jQuery('.dropdown-fixed').hover(function() {
		jQuery('.dropdown-menu-fixed').addClass('show');
		jQuery(this).addClass('show');
	},
	function() {
		jQuery('.dropdown-menu-fixed').removeClass('show');
		jQuery(this).removeClass('show');
	});
});

jQuery(document).ready(function(){
	// init sliders (two separate ones)
	jQuery('.testimony-slider').on('init', function(event, slick){
		jQuery('#testimony-slider-pagination-current').text(`${slick.currentSlide == 0 ? 1 : slick.currentSlide}`)
		jQuery('#testimony-slider-pagination-total').text(`${slick.slideCount / 2}`)
	});
	jQuery('.categories-slider').on('init', function(event, slick){
		jQuery('#categories-slider-pagination-current').text(`${slick.currentSlide == 0 ? 1 : slick.currentSlide}`)
		jQuery('#categories-slider-pagination-total').text(`${slick.slideCount}`)
	});
	jQuery('.testimonial-videos').on('init', function(event, slick){
		jQuery('#testimonial-videos-slider-pagination-current').text(`${slick.currentSlide == 0 ? 1 : slick.currentSlide}`)
		jQuery('#testimonial-videos-slider-pagination-total').text(`${slick.slideCount}`)
	});
	jQuery('.examples-slider').on('init', function(event, slick){
		jQuery('#examples-slider-pagination-current').text(`${slick.currentSlide == 0 ? 1 : slick.currentSlide}`)
		jQuery('#examples-slider-pagination-total').text(`${slick.slideCount}`)
	});
	jQuery('.before-and-after-slider').on('init', function(event, slick){
		jQuery('#before-and-after-pagination-current').text(`${slick.currentSlide == 0 ? 1 : slick.currentSlide}`)
		jQuery('#before-and-after-pagination-total').text(`${slick.slideCount}`)
		console.log(slick)
	});

	// testimony slider settings
	jQuery('.testimony-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		centerMode: false,
		arrows: true,
		infinite: false,
		prevArrow: "<button type='button' class='btn btn-round slick-prev pill'><svg transform=\"rotate(180)\" width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		nextArrow: "<button type='button' class='btn btn-round slick-next pill'><svg width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		responsive: [
			{
				breakpoint: 767.99,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '30px'
				}
			}
		]
	});

	jQuery('.testimonial-videos').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		centerMode: false,
		arrows: true,
		infinite: false,
		prevArrow: "<button type='button' class='btn btn-round slick-prev pill'><svg transform=\"rotate(180)\" width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		nextArrow: "<button type='button' class='btn btn-round slick-next pill'><svg width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		responsive: [
			{
				breakpoint: 767.99,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '30px'
				}
			}
		]
	});

	// categories slider settings
	jQuery('.categories-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		arrows: true,
		infinite: false,
		prevArrow: "<button type='button' class='btn btn-round slick-prev pill'><svg transform=\"rotate(180)\" width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		nextArrow: "<button type='button' class='btn btn-round slick-next pill'><svg width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '30px'
				}
			}
		]
	});
	jQuery('.examples-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		arrows: true,
		infinite: false,
		prevArrow: "<button type='button' class='btn btn-round slick-prev pill'><svg transform=\"rotate(180)\" width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		nextArrow: "<button type='button' class='btn btn-round slick-next pill'><svg width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '0px'
				}
			}
		]
	});
	jQuery('.before-and-after-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		arrows: true,
		infinite: false,
		prevArrow: "<button type='button' class='btn btn-round slick-prev pill'><svg transform=\"rotate(180)\" width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		nextArrow: "<button type='button' class='btn btn-round slick-next pill'><svg width=\"10px\" height=\"15px\" viewBox=\"0 0 10 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Combined Shape</title><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-1231, -2370)\" fill=\"#121A2B\" fill-rule=\"nonzero\"><path d=\"M1231.69668,2370.79511 C1232.12782,2370.38533 1232.82613,2370.38533 1233.25745,2370.79511 L1239.73452,2376.94858 C1239.94484,2377.14849 1240.05889,2377.41568 1240.05889,2377.69331 C1240.05889,2377.97099 1239.94498,2378.23812 1239.73473,2378.43803 L1233.25765,2384.59142 C1232.82634,2385.00138 1232.12802,2385.00138 1231.69686,2384.5914 C1231.26427,2384.18045 1231.26427,2383.51292 1231.69687,2383.10177 L1237.42622,2377.65778 L1237.20422,2377.44778 L1231.69668,2372.28489 C1231.29497,2371.90307 1231.26628,2371.30017 1231.6106,2370.88692 Z\" id=\"Combined-Shape\"></path></g></g></svg></button>",
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '0px'
				}
			}
		],
	});

	// Sliders "onChange" event; to update slider pagination
	jQuery('.testimony-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		jQuery('#testimony-slider-pagination-current').text(`${nextSlide == 0 ? 1 : nextSlide/2+1}`)
	});
	jQuery('.categories-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		jQuery('#categories-slider-pagination-current').text(`${nextSlide == 0 ? 1 : nextSlide+1}`)
	});
	jQuery('.testimonial-videos').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		jQuery('#testimonial-videos-slider-pagination-current').text(`${nextSlide == 0 ? 1 : nextSlide+1}`)
	});
	jQuery('.examples-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		jQuery('#examples-slider-pagination-current').text(`${nextSlide == 0 ? 1 : nextSlide+1}`)
	});
	jQuery('.before-and-after-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		jQuery('#before-and-after-pagination-current').text(`${nextSlide == 0 ? 1 : nextSlide+1}`)
	});

	// Showing mobile header when scrolling past "company-carousel" section
	// let carouselSectionTop = document.querySelector('.company-carousel').offsetTop;
	let heroSectionBottom = document.querySelector('.hero').offsetTop + document.querySelector('.hero').offsetHeight;
	document.addEventListener('scroll', () => {
		if (window.scrollY > heroSectionBottom) {
			document.querySelector('.fixed-header').style.top = '0px';
		} else {
			document.querySelector('.fixed-header').style.top = '-135px';
		}
	})

	// Mobile nav functionality
	let mobileNavOpenBtns = document.querySelectorAll('.mobile-nav-open');

	mobileNavOpenBtns.forEach(btn => {
		btn.addEventListener('click', openMobileMenu);
	})

	// document.querySelector('.mobile-nav-open').addEventListener('click', openMobileMenu);
	document.querySelector('.mobile-nav-close').addEventListener('click', closeMobileMenu);

  	prevAndNextTab();

  	countFormComponent();
  	wizardModalFormNavigation();

	// document.querySelector('.lb-prev').classList.add('lb-custom-arrow');
	// document.querySelector('.lb-next').classList.add('lb-custom-arrow');

	document.querySelectorAll('.custom-radio-input').forEach((input) => {
		input.addEventListener('click', () => {
			setInputBackgroundColourWhenSelected(input);
		});
	})

	try {
		document.querySelector('.btn-plans').addEventListener('click', (e) => {
			e.preventDefault();
		})
	}catch{}

	try {
		document.querySelector('.btn-find-a-plan').addEventListener('click', () => {
			document.querySelector('.find-a-plan-container').style.overflow = 'visible';
			document.querySelector('.form-plans').style.display = 'block';
			document.querySelector('.btn-find-a-plan').style.display = 'none';
		})
	}catch{}
	

  //@TODO run animation only on home page route
	animation();

});

function openMobileMenu() {
	document.querySelector('.mobile-nav').style.display = 'block';
}
function closeMobileMenu() {
	document.querySelector('.mobile-nav').style.display = 'none';
}

// function alterCheckboxBehaviour(checkbox) {
//     var checkboxes = document.querySelectorAll('.custom-checkbox')
//     checkboxes.forEach((item) => {
//         if (item !== checkbox) item.checked = false

// 		item.closest('.btn-radio-container').style.backgroundColor = 'transparent';
//     })

// 	setInputBackgroundColourWhenSelected(checkbox)
// }

function setInputBackgroundColourWhenSelected(input) {
	let radioInputs = document.querySelectorAll('.custom-radio-input')
	console.log(radioInputs);
	radioInputs.forEach((item) => {
		item.closest('.btn-radio-container').style.backgroundColor = 'transparent';
		item.closest('.btn-radio-container').style.border = '1px solid #CFD0D4';
	})
	input.closest('.btn-radio-container').style.backgroundColor = '#121a2b1a';
	input.closest('.btn-radio-container').style.border = '1px solid #121a2b';
}

function prevAndNextTab() {
  
	const prev_button = document.querySelector('.prev-tab');
	const next_button = document.querySelector('.next-tab');
	const nav_tabs = document.querySelectorAll('.nav-tab');
	const tab_progress = document.querySelector('.tab-progress');
	if (!prev_button || !next_button || !nav_tabs || !tab_progress) {
		return;
	}

	tab_progress.innerHTML = `1/${nav_tabs.length}`

  	document.addEventListener('shown.bs.tab', () => {
		nav_tabs.forEach((tab,index) => {
			if (tab.classList.contains('active')) {
		tab_progress.innerHTML = `${index + 1}/${nav_tabs.length}`
			}
		})
  	})

	let show_index = 0;
	next_button.onclick = () => {
		nav_tabs.forEach((tab,index) => {
			if (tab.classList.contains('active')) {
				show_index = index + 1;
				if (show_index > nav_tabs.length - 1) {
					show_index = 0;
				}
			}
		})

		nav_tabs[show_index].click();
		nav_tabs[show_index].scrollIntoView({
			behavior: 'smooth',
			block: 'nearest',
			inline: 'nearest',
		});
	}

	prev_button.onclick = () => {
		nav_tabs.forEach((tab,index) => {
			if (tab.classList.contains('active')) {
				show_index = index - 1;
				if (show_index < 0) {
					show_index = nav_tabs.length - 1;
				}
			}
		})

		nav_tabs[show_index].click();
		nav_tabs[show_index].scrollIntoView({
			behavior: 'smooth',
			block: 'nearest',
			inline: 'nearest',
		});
	}
}


const countFormComponent = () => {
	const counter_container = document.querySelector('.counter-container');
	if (!counter_container) {
		return;
	}

	const count_down_btn = counter_container.querySelector('.count-down');
	const count_up_btn = counter_container.querySelector('.count-up');

	count_down_btn.onclick = () => {
		const count_input = counter_container.querySelector('.content-piece');
		count_input.value--;
		if (count_input.value <= 0) {
			count_input.value = 0;
		}
	}

	count_up_btn.onclick = () => {
		const count_input = counter_container.querySelector('.content-piece');
		count_input.value++;
	}
}


const wizardModalFormNavigation = () => {
	const lead_modal_next_buttons = document.querySelectorAll('.lead-modal-form-next');
	const lead_modal_contents = document.querySelectorAll('.lead-modal-content');

	if (lead_modal_next_buttons.length === 0 || lead_modal_contents.length === 0) {
		return;
	}

	lead_modal_next_buttons.forEach((button) => {
		button.onclick = () => {
			const current_step = button.closest('.lead-modal-content');
			const next_step = lead_modal_contents[button.dataset.nextStep];
			current_step.classList.add('visually-hidden');
			next_step.classList.remove('visually-hidden');
		}
	});

}
